import { render, staticRenderFns } from "./PatientActivityFiltersRep.vue?vue&type=template&id=589f33fd&"
import script from "./PatientActivityFiltersRep.vue?vue&type=script&lang=js&"
export * from "./PatientActivityFiltersRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientActivityFiltersRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports